/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { ManualRefund } from '../models/ManualRefund';
import type { PaginatedManualRefundList } from '../models/PaginatedManualRefundList';

import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';

export class ManualRefundEndpoint {

  constructor(public readonly httpRequest: BaseHttpRequest) {}

  /**
   * ViewSet for managing ManualRefund objects.
   *
   * Provides CRUD operations for manual refunds with proper permission controls.
   * Only support staff and admins can access these endpoints.
   * @returns PaginatedManualRefundList
   * @throws ApiError
   */
  public manualRefundList({
    drivingSchoolId,
    limit,
    offset,
  }: {
    drivingSchoolId?: string,
    /**
     * Number of results to return per page.
     */
    limit?: number,
    /**
     * The initial index from which to return the results.
     */
    offset?: number,
  }): CancelablePromise<PaginatedManualRefundList> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/manual-refund/',
      query: {
        'driving_school_id': drivingSchoolId,
        'limit': limit,
        'offset': offset,
      },
    });
  }

  /**
   * ViewSet for managing ManualRefund objects.
   *
   * Provides CRUD operations for manual refunds with proper permission controls.
   * Only support staff and admins can access these endpoints.
   * @returns ManualRefund
   * @throws ApiError
   */
  public manualRefundRetrieve({
    id,
  }: {
    /**
     * A UUID string identifying this manual refund.
     */
    id: string,
  }): CancelablePromise<ManualRefund> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/manual-refund/{id}/',
      path: {
        'id': id,
      },
    });
  }

}
